/* react */
import { FC, memo } from 'react'
/* utils */
import { classNames } from '@utils'
import 'dayjs/locale/es'
/* types */
import { DatePicker, DatePickerProps } from 'antd'
/* styles */
import './index.scss'
import 'react-datepicker/dist/react-datepicker.css'

interface DatepickerProps {
    name: string
    label: string
    placeholder: string
    className?: string
    dateProps?: DatePickerProps
    keepBorder?: boolean
    onChange: any
}

const DateInput: FC<DatepickerProps> = ({ name, label, placeholder, className, dateProps, keepBorder = false, onChange }) => {
    return (
        <fieldset className="date-field">
            {label && (
                <label htmlFor={name} className="date-field__label">
                    {label && <span>{label}</span>}
                </label>
            )}

            <DatePicker
                placeholder={placeholder}
                onChange={onChange}
                popupClassName="date-field__content__popup"
                className={classNames('date-field__content', keepBorder ? 'date-field__content--keep' : '', className)}
                {...dateProps}
            />
        </fieldset>
    )
}

export default memo(DateInput)
